/* VÆLD — light parallax.
   Two patterns, both subtle and GPU-cheap:
     [data-parallax]      → translates its first child (e.g. drop image)
     [data-parallax-img]  → translates the image itself inside an
                            overflow-hidden figure (manifesto, hero media)
   Speed via data-parallax-speed (default 0.1 for containers, 0.06 for imgs).
   Disabled entirely under prefers-reduced-motion. */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = [];
  var ticking = false;

  function register() {
    items = [];
    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      items.push({ el: el, node: el.firstElementChild || el, speed: parseFloat(el.dataset.parallaxSpeed) || 0.1 });
    });
    document.querySelectorAll('[data-parallax-img]').forEach(function (el) {
      items.push({ el: el, node: el, speed: parseFloat(el.dataset.parallaxSpeed) || 0.06 });
    });
  }

  function update() {
    var vh = window.innerHeight;
    var center = vh / 2;
    for (var i = 0; i < items.length; i++) {
      var rect = items[i].el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var elCenter = rect.top + rect.height / 2;
      var offset = (elCenter - center) * items[i].speed;
      items[i].node.style.transform = 'translate3d(0,' + (-offset).toFixed(2) + 'px,0)';
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  register();
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { register(); update(); });
  document.addEventListener('shopify:section:load', function () { register(); update(); });
})();
